module.exports = __webpack_public_path__ + "img/icn_trash_white.5430bdf7.svg";